import Vue from 'vue';
import Vuetify from 'vuetify/lib';

// import colors from 'vuetify/lib/util/colors';

Vue.use(Vuetify);

const opts = {
  // icons: {
  //   iconfont: 'mdi', // default - only for display purposes
  // },
  theme: {
    dark: false,
    shadowMode: true,
  },
};

export default new Vuetify(opts);
